import { Injectable } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    modalRef:NzModalRef;

    constructor(
        private nzModalService:NzModalService
    ) { }

    close(){
        this.modalRef.close();
    }

    custom(title:any = '', content:any = '', buttons:any = [], params = {}, width = "520px"){
        this.modalRef = this.nzModalService.create({
            nzTitle: title,
            nzContent: content,
            nzFooter: buttons,
            nzComponentParams: params,
            nzWidth: width
        });
    }

    confirm(title:any = '', content:any = '', onOk = null, onCancel = null){

        this.modalRef = this.nzModalService.create({
            nzTitle: title,
            nzContent: content,
            nzOnOk: onOk,
        });
    }
    
}
